import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CreateRoutingModule} from './create-routing.module';
import {TravelCreditService} from '../shared/services/travel-credit.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CreateRoutingModule
  ],
  providers: [ TravelCreditService ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CreateModule { }



// WEBPACK FOOTER //
// ./src/app/create/create.module.ts